module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "boxg"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('strong', [_vm._v("PREFACE")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("n "), _c('em', [_vm._v("Shades of Public Finance, Volume 2,")]), _vm._v(" I am pleased to recount some of the most innovative infrastructure financings that either happened or were waylaid by politics or officious interlopers and to explore the concept of reciprocal bond tax-exempt between federal and state governments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ever since levying an income tax became federal and state law, the market for tax-exempt bonds has created unique opportunities for states, public authorities and municipalities, wealthy individuals, and investment trust fund managers attracted to interest rate incentives and safety features of those bonds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unfortunately, when President John F. Kennedy’s Department of Treasury developed a scoring system to manage the federal budget, it didn’t account for how that system would affect local budgets. For example, this scoring shibboleth was in play in the Tax Cuts and Jobs Act signed by President Donald Trump on December 22, 2017. This legislation shut down a multibillion-dollar tax-exempt refunding bond program that reduced significantly state and local budget and thus tax relief. Presently, the National Association of State Treasurers has as its highest legislative priority the repeal of the relevant provision because the continued low interest rate bond market is ripe for refunding outstanding bonds bearing much higher interest rates. Thus there remains a need for balancing federal/state sovereignty in public financing tools. Several chapters in this book awaken you to the tension created in finding that balance.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("By reading both Volume 1 and Volume 2, you’ll be able to appreciate public financing’s substantial impact on public resources")]), _c('a', {
    attrs: {
      "href": "#/#st_1",
      "id": "st-1"
    }
  }, [_vm._v("*")]), _vm._v(". Pay particular attention in this Volume 2 to the notorious "), _c('em', [_vm._v("Kelo v. City of New London")]), _vm._v(" case in "), _c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(". It is analyzed by me, an insider, using "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("real facts rather than the propaganda put out by interlopers looking for the limelight—those who flamed a fight that was wasteful since the issue had already been settled twenty years before in a fully reasoned decision by the Supreme Court of the United States. The waste of time, opportunities, and taxpayers’ money has not yet been retrievable because the recession and corporate policy changed the feasibility of the plan.")])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_vm._v("While ")]), _c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")]), _vm._v(" describes the shady side of public finance that harms taxpayers and communities, you’ll find most chapters in Volume 2 reveal the best examples of municipal bonds that have been building America for three centuries. They offer much from which to learn. Read on!")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/#st-1",
      "id": "st_1"
    }
  }, [_vm._v("*")]), _vm._v("Please note that in Volume 1, the Puerto Rico chapters are incomplete due to the news changing daily about the territory’s ongoing fiscal and political problems. Updates will be provided in a planned third volume. Perhaps by that publication, fiscal and political resolution benefitting the taxpayer residents of that island will prevail.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-013c4bd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Preface.vue
// module id = 66
// module chunks = 0